import React from "react";
import { withTranslation } from 'react-i18next';
//import configData from '../../../config/config.json';
import { Tune as FilterIcon} from "@material-ui/icons";
import { PeopleAlt as PeopleIcon } from "@material-ui/icons";
import { Close as CloseIcon } from "@material-ui/icons";
import { ChevronRight as ArrowDown } from "@material-ui/icons";
import { KeyboardArrowLeft as ArrowLeft } from "@material-ui/icons";
import { Grid, Button } from "@material-ui/core";
import Calendar from '../../Calendar'
import Destinations from '../../Destinations'
import './index.css';
import { ReactComponent as CalendarIcon} from '../../../assets/images/icons/calendar.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserFriends } from "@fortawesome/free-solid-svg-icons";
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';


const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(0),
    },
}))(MuiDialogContent);
  
const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: 0//theme.spacing(1),
    },
}))(MuiDialogActions);

const DialogTitle = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(0),
    },
}))(MuiDialogTitle);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });


class GlobalFilters extends React.Component {

    constructor (props) {
        super(props)

        this.state = {
            'filters' : {
                ...this.props?.filters
            },
            drawer: {
                open: false
            }
        }


        // Binding
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleShowResults = this.handleShowResults.bind(this);
        
        this.closeDates = this.closeDates.bind(this);
        this.toggleCalendar = this.toggleCalendar.bind(this); 
        
    }

    
    toggleCalendar = (e) => {
        e.stopPropagation();

        this.props.ResetDates()
        
        console.log('toggle picker global')
        /*this.setState(prevState => (
            {
                ...prevState, 
                calendar:!prevState?.calendar,
                
            }
        )
        )*/

        this.props.toggleCalendar(e);
    }
    
    
    handleCalendarChange = (dates, datesType) => {
        this.props.handleCalendarChange(dates, datesType)

        const from = (dates[0])
        const to = (dates[1])

        if (!from && !to) return

        const sqlFromDate = !dates[0]?null:(from.getFullYear()) + '-' + (from.getMonth()*1+1) + '-' + from.getDate();
        const sqlToDate = !dates[1]?null:(to.getFullYear()) + '-' + (to.getMonth()*1+1) + '-' + to.getDate();

        this.setState(prevState=>({
            ...prevState,
            filters: {
                ...prevState.filters,
                from_date: sqlFromDate,
                from: from,
                to_date: sqlToDate,//toDate?toDate.getFullYear() + "-" + ((toDate.getMonth()*1)+1) + '-' + toDate.getDate():null,
                to: to,
                when_caption:  !to?
                    from.getDate() + "/" + (from.getMonth()*1+1) + '/' + (from.getFullYear()+'').replace('20',''):
                    from.getDate() + "/" + (from.getMonth()*1+1) + '/' + (from.getFullYear()+'').replace('20','') + this.props.t('filters.dateRange.to') + (to.getDate() + "/" + (to.getMonth()*1+1)) + '/' + ((to.getFullYear()+'').replace('20',''))
                ,
                dates_type: datesType,
                when: datesType,
                months: [],
                holidays: [],
                months: [], // reset months,
                dow: [], // reset dow selection
                nights: [], // reset nights,
            },
            calendar: !to // show date picker until target date selected

        }))
    }

    handleCloseCalendar = (params) => {
        this.setState(prevState => (
            {
                ...prevState, 
                calendar:false,
                
            }
        ))
    }

    

    handleToggleFilters = (e) => {
        e.preventDefault();
        
        // Create a copy of current state
        if (!this.state?.drawer?.open)
            this.filters_state = JSON.parse(JSON.stringify(this.state));

        this.setState(prevState=>{
            return {
                ...prevState,
                drawer: {
                    open: !this.state?.drawer?.open
                }
            }
        })
    }

    handleToggleSearchPax = (e) => {
        e.preventDefault();

        // Create a copy of current state
        if (!this.state?.drawer?.open)
            this.filters_state = JSON.parse(JSON.stringify(this.state));

        this.setState(prevState=>{
            return {
                ...prevState,
                drawer: {
                    open: !this.state?.drawer?.open
                }
            }
        })  
    }

    closeFiltersWindow = (e) => {
        // Restore previous state (and remove new filters) - since we didn't submit the changes
        this.setState(this.filters_state);
    }
    
    handleShowResults = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.handleToggleFilters(e);
        this.props.handleSubmit(e)
        
    }
    
    closeDates = () => {
        
        this.setState((prevState) => ({
                ...prevState,
                filters: {
                    ...prevState.filters,
                    from_date: '',
                    to_date: '',
                    dates_type: '',
                }
            })
        )
    }

    ResetDow = () => {

        console.log('reset dow')
        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                dow: []
            }
        }));
   }


    closeDestination = () => {
        this.setState(prevState=>({
            ...prevState,
            destinationsWindow: false,
            filters: {
                ...prevState.filters,
                page: '',
                no_more_deals: false
            }
        }))
    }

    closeDate = () => {
        this.setState(prevState=>({
            ...prevState,
            filters: {
                ...prevState.filters,
                month: "",
                from_date: "",
                to_date: "",
                page: '',
                no_more_deals: false
            }
        })/*,()=>
            this.props.sendDataToCaller(this.state.filters, true)
        */)
    }

    render(){
        const { t, i18n } = this.props;
        const currentLang = i18n.language; // 'he', 'en', etc.

        let when_caption = t('filters.dates.allDates');
        let dates_caption = when_caption;

        if (this.props.filters.months && this.props.filters.months?.length>0) {
            if (this.props.filters.months.length>1) {
                when_caption = t('filters.dates.selectedMonths')
            } else {
                when_caption = t('filters.dates.selectedMonth')
            }
        }

        if (this.props.filters.from_date && this.props.filters.to_date) {
            when_caption = t('filters.dates.selectedDates')
            
            const from = this.props.filters.from_date;
            const to = this.props.filters.to_date;

            // fixed according to this suggestions: https://stackoverflow.com/questions/61218243/javascript-returns-nan-only-in-ios-browsers
            const fromDate = new Date(from.split('-')[0],from.split('-')[1]-1,from.split('-')[2]);
            const toDate = new Date(to.split('-')[0],to.split('-')[1]-1,to.split('-')[2]);

          // todo: fix iphone bug showing this as NaN/NaN/NaN...
            when_caption =  (fromDate.getDate() + "/" + (fromDate.getMonth()*1+1) + '/' + (toDate.getFullYear()+'').replace('20','') + t('filters.dateRange.to') + (toDate.getDate() + "/" + (toDate.getMonth()*1+1)) + '/' + (toDate.getFullYear()+'').replace('20',''))
            dates_caption = when_caption
        }

        if (this.props.filters.holidays && this.props.filters.holidays.length > 0) {
            when_caption = t('filters.dates.selectedHolidays')
        }

        return (
            <>
                <div className="GlobalFilters mobile wrapper" id="FiltersWrapper" style={{display:this.props?.hideFiltersBar?'none':'flex'}}>
                    <div className="static">
                        <Button
                            title={t('filters.filterButtonTitle')}
                            className="ActiveFilterButton"
                            variant='outlined'
                            color='primary'
                            onClick={e=>{this.handleToggleFilters(e)}}
                            startIcon={<FilterIcon style={{color:'#1f5981'}} />}
                            test={{'data-testid':'filters-button'}}
                            >{t('filters.filterButton')}
                        </Button>
                    </div>
                    <div className="scrollable">
                        <Button
                            className="ActiveFilterButton Pax"
                            variant='outlined'
                            color='secondary'
                            title={t('filters.pax.changeTitle', {
                                adults: this.props?.filters?.adults,
                                teens: this.props?.filters?.teens,
                                children: this.props?.filters?.children,
                                infants: this.props?.filters?.infants
                            })}
                            onClick={e=>{this.props.gotoStep(e, 0, true)}}
                            startIcon={<PeopleIcon className='BlueIcon' />}
                            endIcon={<ArrowLeft className='Rotate270deg' />}
                            >{
                                this.props?.filters?.teens + this.props?.filters?.children + this.props?.filters?.infants == 0 ?
                                        t('filters.pax.adultsCount', { count: this.props?.filters?.adults }):
                                        this.props?.filters?.adults==2 && this.props?.filters?.children + this.props?.filters?.infants > 0 && this.props?.filters?.teens == 0?
                                            `${t('filters.pax.couple')}+${this.props?.filters?.children*1 + this.props?.filters?.infants*1}`:
                                            t('filters.pax.passengersCount', { count: this.props?.filters?.adults*1 + this.props?.filters?.teens*1 + this.props?.filters?.children*1 + this.props?.filters?.infants*1 })
                            }
                        </Button>
                        <Button
                            className="ActiveFilterButton Pax"
                            title={t('filters.pax.nightsTitle', {
                                nights: this.props?.filters?.nights && this.props?.filters?.nights.length>0?
                                    Math.min(...this.props?.filters?.nights):3
                            })}
                            variant='outlined'
                            color='secondary'
                            onClick={e=>{this.handleToggleFilters(e)}}
                            endIcon={<ArrowLeft className='Rotate270deg' />}
                            >{this.props?.filters?.nights && this.props?.filters?.nights.length>0?
                                Math.min(...this.props?.filters?.nights)
                                :3
                            }{this.props?.filters?.nights.length>0 && Math.min(...this.props?.filters?.nights)!='7'?'+':''} {t('common.labels.nights')}
                        </Button>
                        <Button
                            title={t('filters.pax.starsTitle', {
                                stars: this.props?.filters?.stars.length>0?
                                    Math.min(...this.props?.filters?.stars):'3'
                            })}
                            className="ActiveFilterButton Pax"
                            variant='outlined'
                            color='secondary'
                            onClick={e=>{this.handleToggleFilters(e)}}
                            endIcon={<ArrowLeft className='Rotate270deg' />}
                            >{this.props?.filters?.stars.length>0?
                                Math.min(...this.props?.filters?.stars) :
                                '3'
                              }{this.props?.filters?.stars.length>0 && Math.min(...this.props?.filters?.stars)!='5'?'+':''} {t('filters.stars.threeStarsLabel').replace('3 ', '')}
                        </Button>
                        <Button
                            title={t('filters.pax.mealsTitle', {
                                meals: this.props?.filters?.meals.find(meal=>meal=='BB')?
                                    t('filters.meals.breakfast'):
                                    (
                                        this.props?.filters?.meals.find(meal=>meal=='AI')?
                                            t('filters.meals.allInclusive'):
                                            t('filters.meals.roomOnly')
                                    )
                            })}
                            className="ActiveFilterButton Pax"
                            variant='outlined'
                            color='secondary'
                            onClick={e=>{this.handleToggleFilters(e)}}
                            endIcon={<ArrowLeft className='Rotate270deg' />}
                            >{this.props?.filters?.meals.find(meal=>meal=='BB')?
                                t('filters.meals.breakfast'):
                                (
                                    this.props?.filters?.meals.find(meal=>meal=='AI')?
                                        t('filters.meals.allInclusive'):
                                        t('filters.meals.roomOnly')
                                )
                            }
                        </Button>
                        
                        
                        {this.props?.filters?.from_date && this.props?.filters?.from_date!==''?
                            (
                                <Button
                                    title={t('filters.dates.cancelDateFilter')}
                                    className={`ActiveFilterButton`}
                                    variant='outlined'
                                    color='secondary'
                                    endIcon={<CloseIcon onClick={e=>this.props.ResetDates(true)} />}
                                    >{when_caption}
                                </Button>
                            ):''
                        }


                        {this.props?.filters?.dow?.toString()==='fri,sat'?
                            (
                                <Button
                                    title={t('filters.dates.cancelWeekendFilter')}
                                    className={`ActiveFilterButton`}
                                    variant='outlined'
                                    color='secondary'
                                    endIcon={<CloseIcon onClick={e=>this.props.toggleDOW('fri,say', true)} />}
                                    >{t('filters.dates.weekend')}
                                </Button>
                            ):''
                        }

                        {/*this.state?.filters?.meals.map(meal_code=>{
                            return (
                            <Button
                                key={`btn_${meal_code}`}
                                className={`ActiveFilterButton`}
                                variant='outlined'
                                color='secondary'
                                startIcon={<CloseIcon onClick={e=>this.toggleMealCode(meal_code, true)} />}
                                >{meal_code==='BB'?t('filters.meals.breakfast'):t('filters.meals.allInclusive')}
                            </Button>
                            )
                        })*/}

                        {/*this.state?.filters?.stars.map(star=>{
                            return (
                            <Button
                                key={`stars_${star}`}
                                className={`ActiveFilterButton`}
                                variant='outlined'
                                color='secondary'
                                startIcon={<CloseIcon onClick={e=>this.toggleStars(star, true)} />}
                                >{t('filters.stars.starsCount', { count: star })}
                            </Button>
                            )
                        })*/}

                        <Button
                            title={t('filters.destinations.cancelMonthFilter')}
                            className={`ActiveFilterButton ${(!this.props?.month)?'hidden':''}`}
                            variant='outlined'
                            color='secondary'
                            endIcon={<CloseIcon onClick={e=>this.closeDate()} />}
                            >{this.props?.month_name} {this.props?.year}
                        </Button>

                        <Button
                            title={t('filters.destinations.cancelDestinationFilter')}
                            className={`ActiveFilterButton ${(!this.props?.destination_name)?'hidden':''}`}
                            variant='outlined'
                            color='secondary'
                            endIcon={<CloseIcon onClick={e=>this.closeDestination()}/>}
                            >{this.props?.destination_name}
                        </Button>

                    </div>

                    
                    
                    
                   



                </div>


                <Dialog 
                    fullScreen 
                    open={this.state?.drawer?.open?this.state?.drawer?.open:false} 
                    onClose={e=>{this.closeFiltersWindow(e)}} 
                    className='GlobalFiltersWindow'
                    scroll="paper"
                    TransitionComponent={Transition}
                    style={{padding: 0, zIndex:9999999}}
                    id="filters_window"
                > 
                    <DialogTitle>
                        <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                            <Grid item tabIndex={0}>
                                <Typography variant="h1" style={{flex: 1}}>
                                    {t('filters.title')}
                                </Typography>
                            </Grid>
                            <Grid item >
                                <IconButton edge="start" color="inherit" onClick={e=>{this.closeFiltersWindow(e)}} aria-label="close" 
                                    style={{margin:0, paddingTop: 0}}>
                                        <CloseIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container className="FiltersContent">
                            <Grid item>
                                <label tabIndex={0}>
                                <Grid container>
                                    <Grid item>
                                        <h2> {t('filters.stars.title')} ({t('filters.stars.subtitle')})</h2></Grid>
                                    </Grid>
                                <Grid container>
                                    <Grid>
                                        <Button
                                            title={t('filters.stars.noPreferenceTitle')}
                                            aria-label={t('filters.stars.noPreferenceTitle')}
                                            onClick={e=>this.props.toggleStars('all')}
                                            variant={(this.props?.filters?.stars && this.props.filters.stars?.length==0?'contained':'outlined')}>
                                                {t('filters.stars.noPreference')}</Button>
                                        <Button
                                            title={t('filters.stars.threeStarsTitle')}
                                            aria-label={t('filters.stars.threeStarsTitle')}
                                            onClick={e=>this.props.toggleStars('3')}
                                            variant={(this.props?.filters?.stars.find(star=>star==='3')?'contained':'outlined')}>{t('filters.stars.threeStars')}</Button>
                                        <Button
                                            title={t('filters.stars.fourStarsTitle')}
                                            aria-label={t('filters.stars.fourStarsTitle')}
                                            onClick={e=>this.props.toggleStars('4')}
                                            variant={(this.props?.filters?.stars.find(star=>star==='4')?'contained':'outlined')}>{t('filters.stars.fourStars')}</Button>
                                        <Button
                                            title={t('filters.stars.fiveStarsTitle')}
                                            aria-label={t('filters.stars.fiveStarsTitle')}
                                            onClick={e=>this.props.toggleStars('5')}
                                            variant={(this.props?.filters?.stars.find(star=>star==='5')?'contained':'outlined')}>{t('filters.stars.fiveStars')}</Button>
                                    </Grid>
                                </Grid>
                                </label>


                                <label tabIndex={0}>
                                <Grid container>
                                    <Grid item>
                                        <h2>{t('filters.meals.title')}</h2>
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid>
                                    <Button
                                        title={t('filters.meals.noPreferenceTitle')}
                                        onClick={e=>this.props.toggleMealCode('all')}
                                        variant={(this.props?.filters?.meals && this.props?.filters?.meals.length===0?'contained':'outlined')}>{t('filters.meals.noPreference')}</Button>
                                    <Button
                                        title={t('filters.meals.breakfastTitle')}
                                        onClick={e=>this.props.toggleMealCode('BB')}
                                        variant={(this.props?.filters?.meals.find(meal=>meal==='BB')?'contained':'outlined')}>{t('filters.meals.breakfast')}</Button>
                                    <Button
                                        title={t('filters.meals.allInclusiveTitle')}
                                        onClick={e=>this.props.toggleMealCode('AI')}
                                        variant={(this.props?.filters?.meals.find(meal=>meal==='AI')?'contained':'outlined')}>{t('filters.meals.allInclusive')}</Button>
                                    </Grid>
                                </Grid>
                                </label>


                                <label tabIndex={0}>
                                <Grid container>
                                    <Grid item>
                                        <h2>{t('filters.dates.title')}</h2>
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid>
                                        <Button
                                            title={t('filters.dates.noPreferenceTitle')}
                                            onClick={e=>this.props.toggleDOW('all')}
                                            variant={this.props?.filters?.dow && this.props?.filters?.dow.length==0 && !this.props.filters?.from_date?'contained':'outlined'}>{t('filters.dates.noPreference')}</Button>
                                        <Button
                                            title={t('filters.dates.weekendsTitle')}
                                            onClick={e=>this.props.toggleDOW('fri,sat')}
                                            variant={this.props.filters?.dow.length>0 && ['fri','sat'].every(i=>this.props.filters.dow.includes(i))?'contained':'outlined'}>{t('filters.dates.weekends')}</Button>
                                        {
                                            this.props.filters?.dow.length>0 && ['sun','mon','tue','wed','thu'].every(i=>this.props.filters.dow.includes(i))?
                                            (
                                                <Button
                                                    onClick={e=>this.props.toggleDOW('all')}
                                                    variant={this.props.filters?.dow.length>0 && ['sun','mon','tue','wed','thu'].every(i=>this.props.filters.dow.includes(i))?'contained':'outlined'}>{t('filters.dates.midweek')}</Button>
                                            ):(<></>)
                                        }

                                        {/*<Button
                                            onClick={e=>this.toggleMonth('fri,sat')}
                                            variant={!this.props?.filters?.months || this.props?.filters?.months===''?'contained':'outlined'}>בחר חודשים</Button>*/}
                                        <Button
                                            title={t('filters.dates.selectDatesTitle')}
                                            className="searchToggleButton dates calendar"
                                            variant={this.props.filters?.from_date && this.props.filters?.holidays.length==0 && this.props.filters?.dow.length==0?'contained':'outlined'}
                                            color='primary'
                                            onClick={e=>this.toggleCalendar(e)}
                                            startIcon={<CalendarIcon />}
                                            >{this.props.filters?.from_date && this.props.filters?.holidays.length==0 && this.props.filters?.dow.length==0?dates_caption:t('filters.dates.selectDates')}
                                        </Button>
                                    </Grid>
                                </Grid>
                                </label>

                                <label tabIndex={0}>
                                <Grid container>
                                    <Grid item>
                                        <h2>{t('filters.hotelFeatures.title')}</h2>
                                    </Grid>
                                </Grid>


                                <Grid container>
                                    <Grid item className="NarrowButton" >
                                        <Button
                                            title={t('filters.hotelFeatures.noPreferenceTitle')}
                                            onClick={e=>this.props.toggleResetSpecialHotel()}
                                            variant={!this.props?.filters?.highlights || this.props?.filters?.highlights=={} || (!this.props?.filters?.highlights?.waterpark && !this.props?.filters?.highlights?.casino && !this.props?.filters?.highlights?.luxury && !this.props?.filters?.highlights?.near_chabad && !this.props?.filters?.highlights?.spa) ?'contained':'outlined'}>{t('filters.hotelFeatures.noPreference')}</Button>
                                        <Button
                                            title={t('filters.hotelFeatures.waterparkTitle')}
                                            onClick={e=>this.props.toggleWaterpark()}
                                            variant={this.props?.filters?.highlights?.waterpark?'contained':'outlined'}>{t('filters.hotelFeatures.waterpark')}</Button>
                                        <Button
                                            title={t('filters.hotelFeatures.casinoTitle')}
                                            onClick={e=>this.props.toggleCasino()}
                                            variant={this.props?.filters?.highlights?.casino?'contained':'outlined'}>{t('filters.hotelFeatures.casino')}</Button>
                                        <Button
                                            title={t('filters.hotelFeatures.luxuryTitle')}
                                            onClick={e=>this.props.toggleLuxury()}
                                            variant={this.props?.filters?.highlights?.luxury?'contained':'outlined'}>{t('filters.hotelFeatures.luxury')}</Button>
                                        {currentLang!='ar' ? (<Button
                                            title={t('filters.hotelFeatures.nearChabadTitle')}
                                            onClick={e=>this.props.toggleNearChabad()}
                                            variant={this.props?.filters?.highlights?.near_chabad?'contained':'outlined'}>
                                                {t('filters.hotelFeatures.nearChabad')}</Button>):(<></>)}
                                        <Button
                                            title={t('filters.hotelFeatures.spaTitle')}
                                            onClick={e=>this.props.toggleSpa()}
                                            variant={this.props?.filters?.highlights?.spa?'contained':'outlined'}>
                                                {t('filters.hotelFeatures.spa')}</Button>
                                        {/*<Button 
                                            disabled
                                            onClick={e=>this.props.toggleNearChabad()}
                                            variant={this.props?.filters?.near_chabad?'contained':'outlined'}>
                                        <span style={{color:'#bbb'}}>באתר סקי (בקרוב)</span></Button>*/}
                                    </Grid>
                                </Grid>
                                </label>
                            

                                <label tabIndex={0}>
                                <Grid container>
                                    <Grid item>
                                        <h2>{t('filters.nights.title')}</h2>
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid item className="NarrowButton" >
                                        <Button
                                            title={t('filters.nights.noPreferenceTitle')}
                                            onClick={e=>this.props.toggleNights('all')}
                                            variant={!this.props?.filters?.nights || this.props?.filters?.nights.length==0?'contained':'outlined'}>{t('filters.nights.noPreference')}</Button>
                                        <Button
                                            title={t('filters.nights.threeNightsTitle')}
                                            onClick={e=>this.props.toggleNights('3')}
                                            variant={(this.props?.filters?.nights.find(night=>night==='3')?'contained':'outlined')}>3</Button>
                                        <Button
                                            title={t('filters.nights.fourNightsTitle')}
                                            onClick={e=>this.props.toggleNights('4')}
                                            variant={(this.props?.filters?.nights.find(night=>night==='4')?'contained':'outlined')}>4</Button>
                                        <Button
                                            title={t('filters.nights.fiveNightsTitle')}
                                            onClick={e=>this.props.toggleNights('5')}
                                            variant={(this.props?.filters?.nights.find(night=>night==='5')?'contained':'outlined')}>5</Button>
                                        <Button
                                            title={t('filters.nights.sixNightsTitle')}
                                            onClick={e=>this.props.toggleNights('6')}
                                            variant={(this.props?.filters?.nights.find(night=>night==='6')?'contained':'outlined')}>6</Button>
                                        <Button
                                            title={t('filters.nights.sevenNightsTitle')}
                                            onClick={e=>this.props.toggleNights('7')}
                                            variant={(this.props?.filters?.nights.find(night=>night==='7')?'contained':'outlined')}>7</Button>
                                    </Grid>
                                </Grid>
                                </label>



                                <label tabIndex={0}>
                                <Grid container>
                                    <Grid item>
                                        <h2>{t('filters.airlines.title')}</h2>
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid item className="NarrowButton" >
                                        <Button
                                            title={t('filters.airlines.noPreferenceTitle')}
                                            onClick={e=>this.props.toggleIsraeliAirlines('all')}
                                            variant={!this.props?.filters?.airlines || this.props?.filters?.airlines.length==0?'contained':'outlined'}>{t('filters.airlines.noPreference')}</Button>
                                        <Button
                                            title={t('filters.airlines.israeliOnlyTitle')}
                                            onClick={e=>this.props.toggleIsraeliAirlines('LY,IZ,6H')}
                                            variant={this.props?.filters?.airlines=='LY,IZ,6H'?'contained':'outlined'}>{t('filters.airlines.israeliOnly')}</Button>
                                    </Grid>
                                </Grid>
                                </label>



                                <label tabIndex={0}>
                                <Grid container>
                                    <Grid item>
                                        <h2>{t('filters.destinations.title')}</h2>
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid>
                                    <Button
                                        title={t('filters.destinations.allDestinationsTitle')}
                                        onClick={e=>this.props.resetDestinations(e)}
                                        variant={(!this.props?.filters?.destinations || this.props?.filters?.destinations.length==0?'contained':'outlined')}>{t('filters.destinations.allDestinations')}</Button>
                                    <Button
                                        title={t('filters.destinations.selectDestinationsTitle')}
                                        onClick={e=>this.props.toggleDestinations(e)}
                                        variant={this.props?.filters?.destinations && this.props?.filters?.destinations.length >0?'contained':'outlined'}>
                                            {
                                                this.props?.filters?.destinations && this.props?.filters?.destinations.length > 0?
                                                        t('filters.destinations.selectedDestinations', { count: this.props?.filters?.destinations.length })
                                                    :
                                                        t('filters.destinations.selectDestinations')
                                            }
                                    </Button>
                                    </Grid>
                                </Grid>
                                </label>


                                
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid container>
                            <Grid item xs={12} className="Confirm"  onClick={e=>{this.handleShowResults(e)}} >
                                <Button tabIndex={0}>{t('filters.showResults')} <ArrowLeft /></Button>
                            </Grid>
                        </Grid>
                    </DialogActions>
                </Dialog>

                    
                    
                <Calendar 
                    open={this.state?.calendar?true:false} 
                    sendCalendarData={this.handleCalendarChange} 
                    onCloseCalendar={this.handleCloseCalendar}
                    range={this.props.filters?.dates} 
                    dates_type={this.props.filters?.dates_type} 
                    filters={this.props.filters}>
                </Calendar>

                <Destinations
                    open={this.props?.filters.showDestinationsWindow?true:false} 
                    onConfirmDestinationsSelection={this.props.handleDestinationsChange} 
                    onCloseDestinations={this.props.handleCloseDestinationsWindow}
                    resetDestinations={this.props.resetDestinations}
                    destinations={this.props?.destinations}
                    filters={this.props.filters}>
                </Destinations>
            </>
            
        )
    }



} export default withTranslation()(GlobalFilters)